import { type FunctionComponent } from 'react';
import { getTextButtonStyles } from '../../../helpers/link-style/link-style';
import type { LinkStyleProps } from '../../common-components/link/link.types';
import { BaseButton, type BaseButtonProps } from '../base-button/base-button.component';

export type TextButtonProps = LinkStyleProps & Omit<BaseButtonProps, 'size'>;

export const TextButton: FunctionComponent<TextButtonProps> = ({
	color = 'primary',
	textAlign = 'tc',
	underlineHover,
	underline,
	className = '',
	disabled,
	...remainingProps
}) => {
	let hoverClassName = getTextButtonStyles(color);
	if (underlineHover !== true) {
		hoverClassName = hoverClassName.filter((cls) => cls !== 'underline-hover');
	}

	if (underline === false) {
		hoverClassName = hoverClassName.filter((cls) => cls !== 'underline');
	}

	return (
		<BaseButton
			size={null}
			className={
				// requires pattern in postcss.config.js
				`f-inherit fw-inherit bw0 pa0 link theme-${color} ${underlineHover ? 'underline-hover' : ''} ${disabled ? 'o-50' : ''} ${
					underline ? 'underline' : ''
				} bg-transparent ${textAlign} ${className} ${hoverClassName.join(' ')}`
			}
			disabled={disabled}
			{...remainingProps}
		/>
	);
};
